/**
 * Games Info Recently Played Category Model
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var recentlyPlayedGamesStore = require('stores/recently-played-games/recently-played-games.store.instance');
    var CategoryModel = require('portlets/games-info/categories/gamesinfo.category.model');
    var GamesInfoGameCollection = require('portlets/games-info/gamesinfo.game.collection');
    var device = require('util/device.util');

    module.exports = CategoryModel.extend({
        defaults: {
            isLoading: recentlyPlayedGamesStore.get('state') === 'pending',
            dynamic: true,
            isShowGamesWhileLoading: true
        },

        initialize: function() {
            CategoryModel.prototype.initialize.apply(this, arguments);

            this.get('active') && this._fetch();
        },

        _fetch: function() {
           this.requestHandler(recentlyPlayedGamesStore.fetch());
        },

        _refetch: function() {
            this.requestHandler(recentlyPlayedGamesStore.refetch());
        },

        subscribe: function() {
            CategoryModel.prototype.subscribe.apply(this, arguments);

            this.on('change:active', this.changeHandler);
            core.on('game:launch', this.launchGameHandler.bind(this));
        },

        // trigger only when set `true`
        changeHandler: function() {
            this._refetch();
            this.detachWindowEvent();
        },

        launchGameHandler: function() {
            this.get('active') && this.attachWindowEvent();
        },

        requestHandler: function(dfd) {
            this.set({isLoading: recentlyPlayedGamesStore.get('state') === 'pending'});

            dfd.done(function() {
                    var games = recentlyPlayedGamesStore.state || [];

                    if (games.length) {
                        this.set('games', GamesInfoGameCollection.filterGames(_.pluck(games, 'code')));
                    }
                }.bind(this))
                .fail(function() {
                    this.set('isError', true);
                    core.error('Failed to update recently played games');
                }.bind(this))
                .always(function() {
                    this.set('isLoading', false);
                }.bind(this));
        },

        attachWindowEvent: function() {
            if (device.formFactor !== 'desktop') {
                return;
            }

            $(window).on('focus.recently-category', this.windowFocusListener.bind(this));
        },

        detachWindowEvent: function() {
            $(window).off('focus.recently-category');
        },

        /**
         * [windowFocusListener listener, when game open in new window]
         */
        windowFocusListener: function() {
            this.get('active') ? this._refetch() : this.detachWindowEvent();
        },

        close: function() {
            this.detachWindowEvent();

            CategoryModel.prototype.close(this, arguments);
        }
    });
});
